/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Basket API
 * Documentation of the controllers and endpoints used in the basket-service.
 * OpenAPI spec version: deploy-only-WEBDEV-9162-3063
 */
import type {
  DeliveryStepDTO,
  GetDeliveryDetailsParams,
  GetDeliveryDetailsServerParams,
} from '@as-react/common-types/basket-service';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType, BodyType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
export const useGetDeliveryDetailsHook = () => {
  const getDeliveryDetails = useQueryFetch<DeliveryStepDTO>();

  return useCallback(
    (
      params?: GetDeliveryDetailsParams,
      operationName = 'getDeliveryDetails',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getDeliveryDetails(
        { url: `/api/buy/delivery`, method: 'GET', params, signal },
        { operationName: 'getDeliveryDetails', ...options }
      );
    },
    [getDeliveryDetails]
  );
};

export const useGetDeliveryDetailsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsParams,
  operationName = 'getDeliveryDetails',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/buy/delivery`, queryOptions });

  const getDeliveryDetails = useGetDeliveryDetailsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>> = ({ signal }) =>
    getDeliveryDetails(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliveryDetailsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>
>;
export type GetDeliveryDetailsQueryError = ErrorType<unknown>;

export function useGetDeliveryDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetDeliveryDetailsParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */

export function useGetDeliveryDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsParams,
  operationName = 'getDeliveryDetails',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryDetailsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetDeliveryDetailsQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Saves the delivery step on the basket.
 */
export const useSubmitDeliveryDetailsHook = () => {
  const submitDeliveryDetails = useQueryFetch<DeliveryStepDTO>();

  return useCallback(
    (
      deliveryStepDTO: BodyType<DeliveryStepDTO>,
      operationName = 'submitDeliveryDetails',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return submitDeliveryDetails(
        {
          url: `/api/buy/delivery`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: deliveryStepDTO,
          signal,
        },
        { operationName: 'submitDeliveryDetails', ...options }
      );
    },
    [submitDeliveryDetails]
  );
};

export const useSubmitDeliveryDetailsMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>,
    TError,
    { data: BodyType<DeliveryStepDTO>; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>,
  TError,
  { data: BodyType<DeliveryStepDTO>; operationName?: string },
  TContext
> => {
  const mutationKey = ['submitDeliveryDetails'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const submitDeliveryDetails = useSubmitDeliveryDetailsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>,
    { data: BodyType<DeliveryStepDTO>; operationName?: string }
  > = props => {
    const { data, operationName } = props ?? {};

    return submitDeliveryDetails(data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitDeliveryDetailsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>
>;
export type SubmitDeliveryDetailsMutationBody = BodyType<DeliveryStepDTO>;
export type SubmitDeliveryDetailsMutationError = ErrorType<unknown>;

/**
 * @summary Saves the delivery step on the basket.
 */
export const useSubmitDeliveryDetails = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>,
      TError,
      { data: BodyType<DeliveryStepDTO>; operationName?: string },
      TContext
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useSubmitDeliveryDetailsHook>>>,
  TError,
  { data: BodyType<DeliveryStepDTO>; operationName?: string },
  TContext
> => {
  const mutationOptions = useSubmitDeliveryDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */
export const getDeliveryDetailsServer = (
  params?: GetDeliveryDetailsServerParams,
  operationName = 'getDeliveryDetails',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<DeliveryStepDTO>(
    { url: `/public/checkout/delivery`, method: 'GET', params, signal },
    { operationName: 'getDeliveryDetails', ...options }
  );
};

export const useGetDeliveryDetailsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsServerParams,
  operationName = 'getDeliveryDetails',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryDetailsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/checkout/delivery`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeliveryDetailsServer>>> = ({ signal }) =>
    getDeliveryDetailsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDeliveryDetailsServerQueryResult = NonNullable<Awaited<ReturnType<typeof getDeliveryDetailsServer>>>;
export type GetDeliveryDetailsServerQueryError = ErrorType<unknown>;

export function useGetDeliveryDetailsServer<
  TData = Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetDeliveryDetailsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryDetailsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryDetailsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryDetailsServer<
  TData = Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryDetailsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
          TError,
          Awaited<ReturnType<typeof getDeliveryDetailsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDeliveryDetailsServer<
  TData = Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryDetailsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieve the delivery data of a basket consisting of both delivery options and delivery address (in case of an authenticated user.
 */

export function useGetDeliveryDetailsServer<
  TData = Awaited<ReturnType<typeof getDeliveryDetailsServer>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeliveryDetailsServerParams,
  operationName = 'getDeliveryDetails',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeliveryDetailsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetDeliveryDetailsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Saves the delivery step on the basket.
 */
export const submitDeliveryDetailsServer = (
  deliveryStepDTO: DeliveryStepDTO,
  operationName = 'submitDeliveryDetails',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<DeliveryStepDTO>(
    {
      url: `/public/checkout/delivery`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: deliveryStepDTO,
      signal,
    },
    { operationName: 'submitDeliveryDetails', ...options }
  );
};

export const getSubmitDeliveryDetailsServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitDeliveryDetailsServer>>,
    TError,
    { data: DeliveryStepDTO; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitDeliveryDetailsServer>>,
  TError,
  { data: DeliveryStepDTO; operationName?: string },
  TContext
> => {
  const mutationKey = ['submitDeliveryDetailsServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitDeliveryDetailsServer>>,
    { data: DeliveryStepDTO; operationName?: string }
  > = props => {
    const { data, operationName } = props ?? {};

    return submitDeliveryDetailsServer(data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitDeliveryDetailsServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitDeliveryDetailsServer>>
>;
export type SubmitDeliveryDetailsServerMutationBody = DeliveryStepDTO;
export type SubmitDeliveryDetailsServerMutationError = ErrorType<unknown>;

/**
 * @summary Saves the delivery step on the basket.
 */
export const useSubmitDeliveryDetailsServer = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitDeliveryDetailsServer>>,
      TError,
      { data: DeliveryStepDTO; operationName?: string },
      TContext
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitDeliveryDetailsServer>>,
  TError,
  { data: DeliveryStepDTO; operationName?: string },
  TContext
> => {
  const mutationOptions = getSubmitDeliveryDetailsServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
